
export default {
  name: 'ProductBarcodeLabel',
  props: {
    products: { type: Array, required: true } // [{ id, name, inner_code, barcode }]
  },
  data () {
    return { currentIndex: 0, barcodeDataUrls: {} }
  },
  computed: {
    validProducts () {
      return this.products.filter(p => p.inner_code)
    },
    invalidProducts () {
      return this.products.filter(p => !p.inner_code)
    },
    current () {
      return this.validProducts[this.currentIndex] || null
    }
  },
  watch: {
    current: {
      immediate: true,
      handler (p) { if (p && !this.barcodeDataUrls[p.id]) this.loadBarcode(p) }
    }
  },
  methods: {
    async loadBarcode (product) {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/products/${product.id}/barcode`, {
          params: { format: 'svg' },
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'text'
        })
        if (typeof res.data === 'string' && res.data.includes('<svg')) {
          this.$set(this.barcodeDataUrls, product.id,
            'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(res.data))))
        }
      } catch (e) { /* ignore */ }
    },
    async downloadCurrent () {
      if (!this.current) return
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/products/${this.current.id}/barcode`, {
          params: { format: 'png' },
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: 'image/png' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = `${this.current.inner_code}_label.png`
        document.body.appendChild(a); a.click()
        document.body.removeChild(a); URL.revokeObjectURL(url)
      } catch (e) { alert('下载失败') }
    }
  }
}
